import man from '../../../assets/man.jpeg'
import man2 from '../../../assets/man2.jpeg'
import man3 from '../../../assets/man3.png'

export const reviewData = [
  {
    name: "Emtiaz Hossain",
    man: man,
    job: "Founder Cen",
    des:"Lokamart Id felis ut senectus platea cubilia. Ac litora pretium pellentesque elementum lacus sem arcu justo curae. Mus fermentum habitant conubia pede consectetuer.",
    rating: 4
  },
  {
    name: "Emran Hossain",
    man: man2,
    job: "Frontend Developer",
    des:"Lokamart Id felis ut senectus platea cubilia. Ac litora pretium pellentesque elementum lacus sem arcu justo curae. Mus fermentum habitant conubia pede consectetuer.",
    rating: 5
  },
  {
    name: "Programming Hero",
    man: man3,
    job: "Hero",
    des:"Lokamart Id felis ut senectus platea cubilia. Ac litora pretium pellentesque elementum lacus sem arcu justo curae. Mus fermentum habitant conubia pede consectetuer.",
    rating: 4
  },
  {
    name: "Mehedi Babu",
    man: man,
    job: "Founder Cen",
    des:"Lokamart Id felis ut senectus platea cubilia. Ac litora pretium pellentesque elementum lacus sem arcu justo curae. Mus fermentum habitant conubia pede consectetuer.",
    rating: 4
  },
  {
    name: "Emran Hossain",
    man: man2,
    job: "Frontend Developer",
    des:"Lokamart Id felis ut senectus platea cubilia. Ac litora pretium pellentesque elementum lacus sem arcu justo curae. Mus fermentum habitant conubia pede consectetuer.",
    rating: 5
  },
  {
    name: "Programming Hero",
    man: man3,
    job: "Hero",
    des:"Lokamart Id felis ut senectus platea cubilia. Ac litora pretium pellentesque elementum lacus sem arcu justo curae. Mus fermentum habitant conubia pede consectetuer.",
    rating: 4
  },
]